import { useParticipantsHumansControllerGetHumanEskCardQuery } from '@api/admin/adminGeneratedApi';

export const useGetHumanEskCard = (id: string, skip: boolean = false) => {
  const { data, isLoading, isError } = useParticipantsHumansControllerGetHumanEskCardQuery({ id });

  return { data: data?.data, isLoading, isError };
};
